const en = {
  // Navigation
  nav_home: 'Home',
  nav_about: 'About',
  nav_services: 'Services',
  nav_fleet: 'Fleet',
  nav_schedules: 'Schedules',
  nav_amenities: 'Amenities',
  nav_contact: 'Contact',
  nav_bookNow: 'Book Now',

  // Common
  common_backHome: 'Back to Home',

  // Hero
  hero_tagline: 'Premium Intercity Travel · Panama',
  hero_h1_line1: 'Experience',
  hero_h1_line2: 'Luxury Travel',
  hero_h1_line3: 'Across Panama',
  hero_subtitle: 'Phoenix Transportation redefines intercity travel between Panama City and Chitré — combining first-class comfort, professional service, and absolute reliability.',
  hero_cta1: 'Reserve Your Journey',
  hero_cta2: 'Explore Our Fleet',
  hero_card_dailyDeparture: 'Daily Departure',
  hero_card_perSeat: 'From Per Seat',
  hero_card_journeyTime: 'Journey Time',
  hero_scroll: 'Scroll',

  // About
  about_eyebrow: 'About Phoenix Transportation',
  about_h2_line1: 'Redefining',
  about_h2_line2: 'Intercity Travel',
  about_h2_line3: 'in Panama',
  about_p1: 'Phoenix Transportation is a newly established luxury passenger bus service dedicated to providing safe, comfortable, and reliable intercity transport between <strong>Panama City and Chitré</strong>.',
  about_p2: 'Designed to meet the growing demand for premium travel options, the company combines high-end fleet standards with operational efficiency — bringing a new level of sophistication to Panama\'s intercity routes.',
  about_p3: 'We believe every journey should be a pleasure. Our team of trained professionals is committed to making your travel experience seamless from start to finish.',
  about_motto: 'Luxury. Safety. Reliability.',
  about_stat_buses: 'Luxury Buses',
  about_stat_seats: 'Premium Seats',
  about_stat_service: 'Daily Service',
  about_stat_route: 'City to City',

  // Services
  services_eyebrow: 'Our Services',
  services_h2_line1: 'Comprehensive Travel',
  services_h2_line2: 'Solutions',
  services_subtitle: 'Every aspect of your journey is carefully crafted to deliver the highest standard of intercity travel in Panama.',
  services_0_title: 'Intercity Express Routes',
  services_0_desc: 'Direct, non-stop service between Panama City and Chitré with a daily departure. Our express route is designed for travelers who value punctuality and comfort above all.',
  services_1_title: 'Premium Seating & Comfort',
  services_1_desc: 'Every seat is a premium seat. Enjoy spacious reclining leather chairs, generous legroom, and individual climate control — all designed for the discerning traveler.',
  services_2_title: 'Safety & Reliability',
  services_2_desc: 'Our certified drivers follow strict safety protocols on every route. Our buses are regularly maintained and inspected to ensure you always travel with complete peace of mind.',
  services_3_title: 'Professional Concierge Service',
  services_3_desc: 'Our onboard staff ensures a seamless travel experience. From boarding assistance to in-journey support, we deliver hospitality-level service every single mile.',
  services_4_title: 'Onboard Connectivity',
  services_4_desc: 'Stay connected throughout your journey with complimentary high-speed Wi-Fi. Whether for work or leisure, we keep you online and productive on every trip.',
  services_5_title: 'Luggage Assistance',
  services_5_desc: 'Complimentary luggage handling for all passengers. Our team assists with loading and unloading, so you can focus on the journey ahead without any hassle.',

  // Fleet Home Section
  fleet_eyebrow: 'Our Fleet',
  fleet_h2_line1: 'Luxury Buses Built',
  fleet_h2_line2: 'for Your Comfort',
  fleet_subtitle: 'Our fleet of 2 state-of-the-art luxury coaches is meticulously maintained to deliver the finest travel experience on every route.',
  fleet_specs_title: 'Fleet Specifications',
  fleet_spec_0: '57 Premium Seats',
  fleet_spec_1: 'Full Air Conditioning',
  fleet_spec_2: 'Onboard Wi-Fi',
  fleet_spec_3: 'Spacious Legroom',
  fleet_spec_4: 'Professional Drivers',
  fleet_spec_5: 'Safety Certified',
  fleet_spec_6: 'Luggage Compartment',
  fleet_spec_7: 'USB Charging Ports',
  fleet_bookSeat: 'Book a Seat',
  fleet_route_departure_label: 'Departure',
  fleet_route_arrival_label: 'Arrival',
  fleet_route_duration_label: 'Duration',
  fleet_route_trips_label: 'Daily Trips',
  fleet_route_class_label: 'Class',
  fleet_route_duration_val: '~3.5 Hours',
  fleet_route_trips_val: '1 Departure',
  fleet_route_class_val: 'Luxury',

  // Contact
  contact_eyebrow: 'Get in Touch',
  contact_h2_line1: 'Start Your',
  contact_h2_line2: 'Journey Today',
  contact_phone_label: 'Phone',
  contact_email_label: 'Email',
  contact_route_label: 'Route',
  contact_hours_label: 'Service Hours',
  contact_hours_val: 'Daily Departure: 4:00 AM',
  contact_form_fullName: 'Full Name',
  contact_form_fullName_ph: 'Your full name',
  contact_form_email: 'Email',
  contact_form_email_ph: 'your@email.com',
  contact_form_phone: 'Phone Number',
  contact_form_phone_ph: '+507 0000-0000',
  contact_form_travelDate: 'Travel Date',
  contact_form_route: 'Route',
  contact_form_route_ph: 'Select your route',
  contact_form_route_opt1: 'Panama City → Chitré',
  contact_form_route_opt2: 'Chitré → Panama City',
  contact_form_route_opt3: 'Round Trip',
  contact_form_message: 'Message',
  contact_form_message_ph: 'Any special requests or questions...',
  contact_form_submit: 'Send Inquiry',
  contact_form_sending: 'Sending...',
  contact_form_note: "We'll respond within 24 hours",
  contact_form_required: 'required',
  contact_success_title: 'Message Received!',
  contact_success_desc: "Thank you for reaching out to Phoenix Transportation. We'll get back to you within 24 hours.",

  // Footer
  footer_tagline: "Premium intercity luxury bus service connecting Panama City and Chitré with comfort, safety, and style.",
  footer_motto: 'Luxury. Safety. Reliability.',
  footer_quickLinks: 'Quick Links',
  footer_routes: 'Routes',
  footer_contact: 'Contact',
  footer_route1: 'Panama City → Chitré',
  footer_route2: 'Chitré → Panama City',
  footer_departure_label: 'Daily Departure',
  footer_departure_val: '4:00 AM Every Day',
  footer_journey_label: 'Journey Time',
  footer_journey_val: '~3.5 Hours',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',

  // Schedules Page
  sched_backHome: 'Back to Home',
  sched_title: 'Routes & Schedules',
  sched_subtitle: 'Book your seat on our daily luxury departure — departing at 4:00 AM from both Panama City and Chitré',
  sched_stat_distance_label: 'Distance',
  sched_stat_duration_label: 'Duration',
  sched_stat_departures_label: 'Daily Departures',
  sched_stat_price_label: 'Starting From',
  sched_stat_price_val: '$9 per Seat',
  sched_stat_departures_val: '1 per Direction',
  sched_oneWay: 'One Way',
  sched_roundTrip: 'Round Trip',
  sched_roundTrip_note: "Select one departure from each column — we'll show your total before you book.",
  sched_col1_title: 'Panama City → Chitré',
  sched_col1_sub_ow: 'Departing from Panama City',
  sched_col1_sub_rt: 'Select your outbound departure',
  sched_col2_title: 'Chitré → Panama City',
  sched_col2_sub_ow: 'Departing from Chitré',
  sched_col2_sub_rt: 'Select your return departure',
  sched_selected_badge: 'Selected',
  sched_price_label: 'Price',
  sched_bookNow: 'Book Now',
  sched_select: 'Select',
  sched_selected_btn: 'Selected',
  sched_summary_outbound: 'Outbound',
  sched_summary_return: 'Return',
  sched_summary_total: 'Total',
  sched_not_selected: 'Not selected',
  sched_outbound_detail: 'Panama City → Chitré',
  sched_return_detail: 'Chitré → Panama City',
  sched_bookRoundTrip: 'Book Round Trip',
  sched_selectBothLegs: 'Select Both Legs to Continue',
  sched_terminals_eyebrow: 'Boarding Points',
  sched_terminals_title: 'Terminal Locations',
  sched_terminals_subtitle: 'Find us at these terminals. Arrive at least 20 minutes before your scheduled departure.',
  sched_terminal_address: 'Address',
  sched_terminal_phone: 'Phone',
  sched_terminal_hours: 'Terminal Hours',
  sched_info_title: 'Important Information',
  sched_info_checkin_title: 'Check-in Time',
  sched_info_checkin_desc: 'Please arrive at the terminal at least 20 minutes before departure time',
  sched_info_baggage_title: 'Baggage Policy',
  sched_info_baggage_desc: '2 carry-on bags (max 10kg each) and 2 checked bags (max 23kg each) included',
  sched_info_cancel_title: 'Cancellation Policy',
  sched_info_cancel_desc: 'Free cancellation up to 24 hours before departure. 50% refund within 24 hours',
  sched_info_ticket_title: 'Ticket Validation',
  sched_info_ticket_desc: 'Valid government-issued ID required. Digital or printed tickets accepted',

  // Amenities Page
  amen_eyebrow: 'On Board Experience',
  amen_title1: 'Premium',
  amen_title2: 'Amenities',
  amen_subtitle: 'Every detail on board is thoughtfully curated to ensure your journey is as enjoyable as the destination.',
  amen_stat1_val: '7',
  amen_stat1_label: 'Premium Features',
  amen_stat2_val: '100%',
  amen_stat2_label: 'Comfort Guaranteed',
  amen_stat3_val: '248 km',
  amen_stat3_label: 'Luxury Route',
  amen_wifi_title: 'High-Speed Wi-Fi',
  amen_wifi_desc: "Stay connected throughout your journey with complimentary high-speed onboard Wi-Fi, keeping you productive and entertained.",
  amen_wifi_detail: 'Our onboard Wi-Fi is powered by a dedicated satellite connection, ensuring stable speeds even on the open road. Stream, browse, and stay in touch with no interruptions.',
  amen_ac_title: 'Full Air Conditioning',
  amen_ac_desc: "Individual climate zones ensure every passenger enjoys the perfect temperature, regardless of Panama's tropical heat outside.",
  amen_ac_detail: 'Each section of the bus maintains its own climate zone with precise temperature control. No more battling over the thermostat — everyone rides in comfort.',
  amen_seats_title: 'Spacious Leather Seats',
  amen_seats_desc: 'Wide, premium leather seats designed for maximum comfort — giving every passenger the space they deserve on every journey.',
  amen_seats_detail: 'Our seats are crafted from full-grain leather with ergonomic lumbar support. With extra-wide seating and generous legroom, every journey feels first-class.',
  amen_recline_title: 'Fully Reclining Seats',
  amen_recline_desc: 'Adjust your seat to the perfect angle and settle in for the ride. Our fully reclining seats let you travel in complete relaxation.',
  amen_recline_detail: 'Each seat reclines smoothly to your preferred angle with a simple button press. Whether you want to sit upright or lean back and nap, your seat adapts to you.',
  amen_screen_title: 'Entertainment Screens',
  amen_screen_desc: 'Enjoy onboard entertainment with individual screens featuring movies, music, and curated content to make the miles fly by.',
  amen_screen_detail: 'Every seat is fitted with a personal HD touchscreen loaded with a curated library of movies, series, music, and podcasts — the perfect travel companion.',
  amen_usb_title: 'USB Charging Ports',
  amen_usb_desc: 'Every seat features individual USB charging ports so your devices stay fully powered throughout the entire trip.',
  amen_usb_detail: 'Never arrive with a dead battery. Each seat includes a USB-A and USB-C port delivering fast-charge speeds, so your phone, tablet, or laptop stays ready.',
  amen_luggage_title: 'Secure Luggage Storage',
  amen_luggage_desc: 'Large luggage compartments and overhead storage keep your belongings safe and easily accessible for the entire journey.',
  amen_luggage_detail: 'Generous underbus storage compartments and overhead bins provide ample space for all your bags. Attendants help load and unload at every stop.',
  amen_learnMore: 'Learn more',
  amen_showLess: 'Show less',
  amen_gallery_eyebrow: 'Step Inside',
  amen_gallery_title1: 'Interior',
  amen_gallery_title2: 'Walkthrough',
  amen_gallery_subtitle: 'Take a visual tour of every corner of the cabin — from the moment you board to the seat you settle into.',
  amen_gal1_label: 'Main Cabin',
  amen_gal1_caption: 'Rows of wide premium leather seats stretch down the full length of the cabin.',
  amen_gal2_label: 'Premium Seating',
  amen_gal2_caption: 'Full-grain leather with lumbar support and individual recline controls at your fingertips.',
  amen_gal3_label: 'Entertainment',
  amen_gal3_caption: 'Personal HD touchscreens at every seat loaded with movies, music and curated content.',
  amen_gal4_label: 'Charging & Connectivity',
  amen_gal4_caption: 'USB-A and USB-C fast-charge ports built right into every armrest so you never run low.',
  amen_gal5_label: 'Climate Control',
  amen_gal5_caption: 'Individual overhead air vents let each passenger dial in their perfect temperature.',
  amen_gal6_label: 'Luggage Storage',
  amen_gal6_caption: 'Generous underfloor compartments hold your bags safely throughout the entire journey.',
  amen_zoom_hint: 'Click to enlarge',
  amen_cta_eyebrow: 'Ready to Travel?',
  amen_cta_title: 'Experience Every Amenity on Your Next Journey',
  amen_cta_subtitle: "Book your seat today and discover why Phoenix Transportation is Panama's premier intercity luxury service.",
  amen_cta_btn1: 'View Schedules & Book',
  amen_cta_btn2: 'Contact Us',

  // Fleet Page
  fleet_page_eyebrow: 'Our Fleet',
  fleet_page_h1_line1: 'Meet the Coaches That',
  fleet_page_h1_line2: 'Define the Journey',
  fleet_page_subtitle: 'Two state-of-the-art luxury coaches — built for performance, designed for comfort, and maintained to perfection on every route between Panama City and Chitré.',
  fleet_page_stat1_label: 'Luxury Coaches',
  fleet_page_stat2_label: 'Total Seats',
  fleet_page_stat3_label: 'Days a Year',
  fleet_page_stat4_label: 'Luxury Route',
  fleet_page_badge_flagship: 'Flagship',
  fleet_page_badge_newest: 'Newest',
  fleet_page_seats_label: 'Seats',
  fleet_page_tab_exterior: 'exterior',
  fleet_page_tab_interior: 'interior',
  fleet_page_tab_seat: 'Seating',
  fleet_page_specs_title: 'Specifications',
  fleet_page_features_title: 'On Board Features',
  fleet_page_seatmap_title: 'Seat Map',
  fleet_page_seatmap_note: 'Hover a seat to highlight · All seats are premium class',
  fleet_page_spec_capacity: 'Capacity',
  fleet_page_spec_year: 'Year',
  fleet_page_spec_length: 'Length',
  fleet_page_spec_engine: 'Engine',
  fleet_page_spec_climate: 'Climate',
  fleet_page_spec_wifi: 'Connectivity',
  fleet_page_spec_entertainment: 'Entertainment',
  fleet_page_spec_charging: 'Charging',
  fleet_page_spec_val_capacity: '57 Seats',
  fleet_page_spec_val_engine: 'Euro VI Diesel',
  fleet_page_spec_val_climate: 'Dual-Zone A/C',
  fleet_page_spec_val_wifi: 'Satellite Wi-Fi',
  fleet_page_spec_val_entertainment: 'Individual HD Screens',
  fleet_page_spec_val_charging: 'USB-A + USB-C per Seat',
  fleet_page_highlight_0: 'Fully reclining premium leather seats',
  fleet_page_highlight_1: 'Individual HD entertainment touchscreens',
  fleet_page_highlight_2: 'Satellite-powered onboard Wi-Fi',
  fleet_page_highlight_3: 'Dual-zone precision air conditioning',
  fleet_page_highlight_4: 'USB-A and USB-C fast charging at every seat',
  fleet_page_highlight_5: 'Large underfloor luggage compartments',
  fleet_page_highlight_6: 'Onboard restroom',
  fleet_page_highlight_7: 'Professional bilingual attendant on every trip',
  fleet_page_bus1_name: 'Phoenix I',
  fleet_page_bus1_tagline: 'The Flagship Experience',
  fleet_page_bus2_name: 'Phoenix II',
  fleet_page_bus2_tagline: 'Equally Luxurious, Always Ready',
  fleet_page_safety_eyebrow: 'Your Safety, Our Priority',
  fleet_page_safety_title1: 'Built on a',
  fleet_page_safety_title2: 'Foundation of Safety',
  fleet_page_safety_0_title: 'Safety Certified',
  fleet_page_safety_0_desc: 'Every vehicle holds full Panamanian transport authority certification and is inspected monthly.',
  fleet_page_safety_1_title: 'Professional Drivers',
  fleet_page_safety_1_desc: 'All drivers carry a minimum of 10 years of long-haul experience and pass regular wellness checks.',
  fleet_page_safety_2_title: 'CCTV Monitoring',
  fleet_page_safety_2_desc: 'Interior and exterior cameras operate throughout every journey for passenger safety.',
  fleet_page_safety_3_title: 'First Aid Ready',
  fleet_page_safety_3_desc: 'Certified first aid kits and trained staff are present on every trip.',
  fleet_page_safety_4_title: 'GPS Tracked',
  fleet_page_safety_4_desc: 'Real-time GPS tracking on every coach, visible to dispatch 24/7.',
  fleet_page_safety_5_title: 'Fire Suppression',
  fleet_page_safety_5_desc: 'Automatic engine-bay fire suppression systems installed on both coaches.',
  fleet_page_cta_eyebrow: 'Ready to Ride?',
  fleet_page_cta_title: 'Claim Your Seat on Phoenix I or Phoenix II',
  fleet_page_cta_subtitle: 'One daily departure from both Panama City and Chitré at 4:00 AM. Seats are limited — secure yours today.',
  fleet_page_cta_btn1: 'View Schedules & Book',
  fleet_page_cta_btn2: 'Explore Amenities',
  fleet_page_seatmap_front: 'Front',
  fleet_page_seatmap_rear: 'Rear',
  fleet_page_seatmap_door: 'Door',
  fleet_page_seatmap_all_premium: 'All seats are premium class',
};

export default en;
